module.exports = __webpack_public_path__ + "img/glow-vilolet-medium.a88e3f90.png";